import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

export const mcpTokenStatusesQueryKey = (orgId: string | undefined) => [
  "mcpTokenStatuses",
  orgId,
];

export function useMcpTokenStatuses(orgId: string | undefined) {
  const { mcpRegistryService } = useDomainServices();

  return useQuery({
    queryKey: mcpTokenStatusesQueryKey(orgId),
    queryFn: ({ signal }) =>
      mcpRegistryService.listTokenStatuses(orgId!, { abortSignal: signal }),
    enabled: orgId !== undefined,
    staleTime: 30_000,
  });
}
